module.exports = __webpack_public_path__ + "img/elementwidths_jak.e564b28c.png";